import React from 'react';

import { AuthorizationProvider } from './app/AuthorizationProvider';
import { BackgroundTasksStatusProvider } from './app/BackgroundTasksStatusProvider';
import { ConfigurationProvider, RuntimeConfiguration } from './app/ConfigurationProvider';
import { DataProvider } from './app/DataProvider';
import { SessionProvider } from './app/SessionProvider';
import { Metrics } from './app/metrics/Metrics';
import { PushNotificationProvider } from './app/push/PushNotificationProvider';
import { LayoutProvider } from './components/LayoutNext/LayoutProvider';
import { BottomPanelProvider } from './components/layout/BottomPanel';
import { SidebarProvider } from './components/layout/Sidebar';
import { Router } from './router/Router';

export const App: React.FC<RuntimeConfiguration> = ({ env }) => (
  <ConfigurationProvider env={env}>
    <AuthorizationProvider>
      <SessionProvider>
        <DataProvider>
          <PushNotificationProvider>
            <BackgroundTasksStatusProvider>
              <Metrics />
              <BottomPanelProvider>
                <SidebarProvider>
                  <LayoutProvider>
                    <Router />
                  </LayoutProvider>
                </SidebarProvider>
              </BottomPanelProvider>
            </BackgroundTasksStatusProvider>
          </PushNotificationProvider>
        </DataProvider>
      </SessionProvider>
    </AuthorizationProvider>
  </ConfigurationProvider>
);
